// extracted by mini-css-extract-plugin
export default {"menu":"BurguerMenuNav_menu__1glsD","navLink":"BurguerMenuNav_navLink__X0nq1"};